import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TMessageReactionEvent } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetMessageReactionHistory = async ({
  messageId,
  messageEra
}: {
  messageId: number;
  messageEra: string;
}): Promise<{
  data: {
    events: TMessageReactionEvent[];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    messageId: number;
    events: TMessageReactionEvent[];
  }>(`user/getMessageReactionHistory`, {
    messageId,
    messageEra
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        events: reduce(() => data.events, [])
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        events: []
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        events: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
